import React, { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { clearAuthSession } from '../utils/passwordRecovery';

/**
 * Legacy routes redirect to /login?mode=reset&token=... (DEC-Store format).
 */
const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => {
    const mode = searchParams.get('mode');
    if (mode === 'reset') return String(searchParams.get('token') || '').trim();
    return String(searchParams.get('token') || searchParams.get('resetToken') || '').trim();
  }, [searchParams]);

  useEffect(() => {
    clearAuthSession();
    if (token) {
      const params = new URLSearchParams({ mode: 'reset', token });
      navigate(`/login?${params.toString()}`, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate, token]);

  return (
    <div className="login-container">
      <div className="login-card">
        <p style={{ textAlign: 'center', color: '#64748b', fontSize: 14 }}>Opening password reset...</p>
      </div>
    </div>
  );
};

export default ResetPassword;
